import React, {Component} from 'react';
import {Row, Col} from 'react-bootstrap';

export default class AddMember extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
		};
	}

	render() {
		return (
			<Row>
				AddMember
			</Row>
		);
	}
}